/**
 * 模組頁面代碼 : 1430-UI-02
 * 頁面說明 : 新增修改機器分配管理畫面
 * @module web/modules/department/components/MachineModal
 */

// ----- import from npm modules ----
import $ from 'jquery';
import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';

// ----- import from local modules -----
import enumList from 'web/utils/enumList';
import {BaseComponent} from 'web/components/BaseComponent';

// ----- constants -----
import {TITLE_CUSTOMER_NEW, TITLE_CUSTOMER_EDIT} from 'web/constant';
import {showMessage} from 'web/utils/modalHelper';
import {addMachine, editMachine} from 'web/redux/actions/MachineActions';
import {Typeahead, Menu, MenuItem} from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';

const MachineModal = React.forwardRef((props, ref) => {
  const {toggleMachineAddModal, toggleMachineEditModal, reloadDepartmentList, mode, machineItem} = props;
  const dispatch = useDispatch();
  const baseComponent = new BaseComponent(props);
  const [modalRecordYear, setModalRecordYear] = useState('');
  const [modalDeliveryCode, setModalDeliveryCode] = useState('');
  const [modalMachineModel, setModalMachineModel] = useState('');
  const [modalMachineSerialNumber, setModalMachineSerialNumber] = useState([]);
  const [modalMachineType, setModalMachineType] = useState('');
  const [modalMemo, setModalMemo] = useState('');

  const machineTypeList = Object.keys(enumList.machineTypes).map((machineType) => {
    return {
      machineTypeName: enumList.machineTypes[machineType],
      value: machineType,
    };
  });

  const [invalidShow, setInvalidShow] = useState('none');
  const modalIcon = mode === enumList.modalMode.new ? '#ico-plus' : '#ico-edit';
  const modalTitleText = mode === enumList.modalMode.new ? TITLE_CUSTOMER_NEW : TITLE_CUSTOMER_EDIT;

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    // 檢查表單是否驗證通過
    if (form.checkValidity() === false) {
      setInvalidShow('block');
      return;
    }
    form.classList.add('was-validated');

    const req = {
      recordYear: modalRecordYear,
      deliveryCode: modalDeliveryCode,
      machineModel: modalMachineModel,
      machineSerialNumber: modalMachineSerialNumber,
      machineType: modalMachineType[0].value,
      memo: modalMemo,
    };
    if (mode === enumList.modalMode.edit) {
      submitEditMachine(req);
      toggleMachineEditModal(false);
    }
    if (mode === enumList.modalMode.new) {
      submitAddMachine(req);
      toggleMachineAddModal(false);
    }
    resetForm(form);
  };

  const submitAddMachine = (req) => {
    dispatch(addMachine(req)).then((res) => {
      const statusCode = res.payload.code;
      if (statusCode.isSuccessCode()) {
        const customerList = res.payload.result;
        showMessage(enumList.messageModalMode.info, '新增成功');
        toggleMachineAddModal(false);
        reloadDepartmentList();
      } else {
        toggleMachineAddModal(false);
        showMessage(enumList.messageModalMode.error, 'error', res.payload.message);

        console.error('fetchDepartmentList error', res);
      }
    });
  };
  const submitEditMachine = (req) => {
    dispatch(editMachine(req)).then((res) => {
      const statusCode = res.payload.code;
      if (statusCode.isSuccessCode()) {
        const customerList = res.payload.result;
        showMessage(enumList.messageModalMode.info, '更新成功');
        toggleMachineEditModal(false);
        reloadDepartmentList();
      } else {
        toggleMachineEditModal(false);
        showMessage(enumList.messageModalMode.error, 'error', res.payload.message);
      }
    });
  };

  const resetForm = (form) => {
    form.classList.remove('was-validated');
    setModalRecordYear('');
    setModalDeliveryCode('');
    setModalMachineModel('');
    setModalMachineSerialNumber('');
    setModalMachineType('');
    setModalMemo('');
  };

  useEffect(() => {
    setModalRecordYear(machineItem ? machineItem.recordYear : '');
    setModalDeliveryCode(machineItem ? machineItem.deliveryCode : '');
    setModalMachineModel(machineItem ? machineItem.machineModel : '');
    setModalMachineSerialNumber(machineItem ? machineItem.machineSerialNumber : '');
    setModalMachineType(machineItem ? machineItem.machineType : '');
    setModalMemo(machineItem ? machineItem.memo : '');
  }, [machineItem]);

  return (
    <div
      ref={ref}
      className="modal fade"
      id="modalDepartment"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="modalDepartmentLabel"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <form className="modal__form modal-content needs-validation" id="modalMachineForm" noValidate onSubmit={handleSubmit}>
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="modalMachineLabel">
              <div className="modal__title__badge">
                <svg className="badge__icon" aria-hidden="true">
                  <use href={modalIcon}></use>
                </svg>
              </div>
              <div className="modal__title__text">{modalTitleText}</div>
            </h1>
            <button type="button" className="btn-close btn-cancel" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <div className="d-flex flex-column gap-3 px-2">
              <div className="modal__form__catagory row">
                <div className="col-12">
                  <div className="row">
                    <div className="col-6">
                      <label htmlFor="modalRecordYear" className="form-label">
                        年度*
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="modalRecordYear"
                        name="modalRecordYear"
                        value={modalRecordYear}
                        onChange={(e) => setModalRecordYear(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-6">
                      <label htmlFor="modalDeliveryCode" className="form-label">
                        交機編號*
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="modalDeliveryCode"
                        name="modalDeliveryCode"
                        value={modalDeliveryCode}
                        onChange={(e) => setModalDeliveryCode(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-6">
                      <label htmlFor="modalMachineModel" className="form-label">
                        機械型式*
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="modalMachineModel"
                        name="modalMachineModel"
                        value={modalMachineModel}
                        onChange={(e) => setModalMachineModel(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-6">
                      <label htmlFor="modalMachineSerialNumber" className="form-label">
                        機械番號*
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="modalMachineSerialNumber"
                        name="modalMachineSerialNumber"
                        value={modalMachineSerialNumber}
                        onChange={(e) => setModalMachineSerialNumber(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-6">
                      <label htmlFor="modalMachineType" className="form-label">
                        機種*
                      </label>
                      <Typeahead
                        id="modalMachineType"
                        value={modalMachineType}
                        size="sm"
                        onChange={setModalMachineType}
                        selected={modalMachineType}
                        inputProps={{required: true}}
                        options={machineTypeList}
                        labelKey="machineTypeName"
                        // placeholder="請輸入縣市名稱"
                        renderInput={({inputRef, referenceElementRef, ...inputProps}) => (
                          <input
                            {...inputProps}
                            className="rbt-input-main form-control rbt-input form-control-sm form-select"
                            ref={(node) => {
                              inputRef(node);
                              referenceElementRef(node);
                            }}
                          />
                        )}
                        renderMenu={(results, menuProps) => (
                          <Menu id={menuProps.id} innerRef={menuProps.innerRef} maxHeight="90px" style={menuProps.style}>
                            {results.map((result, index) => (
                              <MenuItem option={result} position={index} key={index}>
                                {result.cityName}
                              </MenuItem>
                            ))}
                          </Menu>
                        )}
                      />
                    </div>
                    <div className="col-6">
                      <label htmlFor="modalMemo" className="form-label">
                        備註
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="modalMemo"
                        name="modalMemo"
                        value={modalMemo}
                        onChange={(e) => setModalMemo(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="alert alert-warning global-invalid-feedback" style={{display: invalidShow}}></div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-cancel" data-bs-dismiss="modal">
              取消
            </button>
            <button type="submit" className="btn btn-primary">
              儲存
            </button>
          </div>
        </form>
      </div>
    </div>
  );
});

export default MachineModal;
